import React from 'react'
import { Select } from './styles'

const Creatable = ({options, ...props}) => {
  return (
    <Select options={options}  {...props}/>
  )
}

export default Creatable